import { useState, useRef } from "react";
import Dropdown from "../../../designSystem/c-organism/dialogs/Dropdown";
import style from "./StyleSwatch.module.css";

const StyleSwatch = (props) => {
  const { currentStyle, styleOptions, onStyleChange, disabled = false, variant = "text" } = props;
  const [showDropdown, setShowDropdown] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({});
  const swatchButtonRef = useRef(null);

  function handleSwatchClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (disabled) return;
    
    if (swatchButtonRef.current) {
      const rect = swatchButtonRef.current.getBoundingClientRect();
      setDropdownPosition({
        left: rect.left,
        top: rect.bottom + 4,
      });
    }
    setShowDropdown(!showDropdown);
  }

  function handleStyleSelect(styleId) {
    onStyleChange(styleId);
    setShowDropdown(false);
  }

  // Get the swatch class based on variant
  const swatchClassName = variant === "phases" 
    ? `${style.styleSwatch} ${style[`phasesStyle${currentStyle?.replace("style", "") || "1"}`] || ""}`
    : variant === "text"
    ? `${style.styleSwatch} ${style[`textStyle${currentStyle?.replace("style", "") || "1"}`] || ""}`
    : style.styleSwatch;

  return (
    <div className={style.styleSelector}>
      <button
        ref={swatchButtonRef}
        type="button"
        className={swatchClassName}
        disabled={disabled}
        onClick={handleSwatchClick}
        onMouseDown={(e) => e.preventDefault()}
        title="Style"
      >
        <span className={style.styleSwatchLabel}>A</span>
      </button>
      <Dropdown
        show={showDropdown}
        onClose={() => setShowDropdown(false)}
        style={dropdownPosition}
      >
        <div className={style.swatches}>
          {styleOptions.map((option) => {
            const optionClassName = variant === "phases"
              ? `${style.styleOption} ${style[`phasesStyle${option.id.replace("style", "")}`]} ${currentStyle === option.id ? style.active : ''}`
              : variant === "text"
              ? `${style.styleOption} ${style[`textStyle${option.id.replace("style", "")}`]} ${currentStyle === option.id ? style.active : ''}`
              : `${style.styleOption} ${currentStyle === option.id ? style.active : ''}`;

            return (
              <button
                key={option.id}
                type="button"
                className={optionClassName}
                disabled={disabled}
                onClick={() => handleStyleSelect(option.id)}
                title={option.label || option.id}
              >
                A
              </button>
            );
          })}
        </div>
      </Dropdown>
    </div>
  );
};

export default StyleSwatch;

